<template>
  <div class="bbs_router">
    <!-- 承载bbs相关路由 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'BBS',
  components: {
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
.bbs_router {
  width: 100%;
  height: 100%;
}
</style>
